var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "70%",
        "close-on-click-modal": false,
        "destroy-on-close": "",
        center: "",
        title: "聊天内容"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close
      }
    },
    [
      _c(
        "div",
        { staticClass: "filter-bar" },
        [
          _c("el-date-picker", {
            staticClass: "filter-date-picker",
            attrs: {
              size: "mini",
              type: "daterange",
              editable: false,
              "value-format": "yyyy-MM-dd",
              "range-separator": "~",
              "start-placeholder": "统计时间",
              "end-placeholder": "统计时间",
              clearable: false
            },
            on: { change: _vm.timeIntervalChange },
            model: {
              value: _vm.searchParams.timeInterval,
              callback: function($$v) {
                _vm.$set(_vm.searchParams, "timeInterval", $$v)
              },
              expression: "searchParams.timeInterval"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "staffScrollbar",
          staticClass: "newKeyWordStatisticsDetailChatContent-container"
        },
        [
          _vm.pageInfo.totals == 0 && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "chat-complate",
                  staticStyle: { height: "100%" }
                },
                [
                  _c("span", { staticClass: "empty-text" }, [
                    _vm._v("暂无数据")
                  ])
                ]
              )
            : _vm._e(),
          _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            attrs: {
              id: "new-conversation-iframe-container",
              "element-loading-text": "拼命加载中..."
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }